import React from 'react'
import { useState ,useEffect} from "react";
import "./SubStyle.css"
import dashboard from "../images/CQC-Dashboard.png";

const coreValuesData  = [
  {
    title: "CQC-focused",
    description: "Regulatory expertise",
  },
  {
    title: "Evidence-led",
    description: "Clear, objective findings",
  },
  {
    title: "Practical",
    description: "Actions your team can deliver",
  },
  {
    title: "Responsive",
    description: "Support when it matters",
  },
];

const financeServices = [
  {
    id: "01",
    title: "CQC registration",
    description:
      "End-to-end support for new provider, registered manager and location applications, including your Statement of Purpose.",
  },
  {
    id: "02",
    title: "Mock inspections",
    description:
      "A robust review against the CQC quality statements, with evidence-based findings and a practical improvement plan.",
  },
  {
    id: "03",
    title: "Compliance audits",
    description:
      "Focused audits of governance, care records, medicines, safeguarding, recruitment and other key regulatory areas.",
  },
  {
    id: "04",
    title: "Inspection readiness",
    description:
      "Evidence reviews, staff preparation and leadership support so your service can approach inspection with confidence.",
  },
  {
    id: "05",
    title: "Action plans & recovery",
    description:
      "Structured support following inspection, concerns or enforcement action, with clear priorities, owners and evidence.",
  },
  {
    id: "06",
    title: "Ongoing CQC assurance",
    description:
      "Regular compliance reviews, regulatory updates and independent oversight to help you remain inspection-ready.",
  },
];

const financeData = [
  {
    no: "01",
    heading: "Care-sector experience",
    text: "Advice grounded in the realities of regulated care services and current CQC expectations.",
  },
  {
    no: "02",
    heading: "Honest assurance",
    text: "Independent findings that recognise good practice and clearly identify gaps or risk.",
  },
  {
    no: "03",
    heading: "Support beyond the audit",
    text: "Prioritised actions, evidence guidance and follow-up support to help improvements become embedded.",
  },
];

const careTypes = [
  "Residential care homes",
  "Nursing homes",
  "Domiciliary care",
  "Supported living",
  "Care home groups",
  "New care providers",
];


const CQC_Services = () => {

  const handleSubmit = (e) => {
  e.preventDefault();
 console.log("Consultation form submitted");
  const formData = new FormData(e.target);

  const data = {
    fullName: formData.get("fullName"),
    email: formData.get("email"),
    organisation: formData.get("organisation"),
  };

  console.log("Form Data:", data);

  // Example:
  // Send data to your API here
};

 // open page on top //
         useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
        
          // open page on top // 
          
  return (
     <>
     <section className="finances">

      <div className="finances-left">

        <span className="tag">CQC EXPERTISE FOR CARE PROVIDERS </span>
        <h1>CQC compliance, approached with <span> confidence.</span></h1>

        <p>
         Specialist registration, mock inspection, compliance and improvement
          support for care providers. Know where you stand, what to strengthen
           and how to evidence good care.
        </p>

        <div className="buttons">

          <button className="primary">
            <a className="primary-pera" href='mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo'>Book a free consultation</a>
          </button>

          <a href="#HOW WE CAN HELP">
            Explore our services
          </a>

        </div>

        <div className="bottom-text">
          ✓ Built around the CQC framework. Practical guidance aligned to quality statements and regulatory 
          requirements.
        </div>

      </div>

      <div className="finances-right">

        <img src={dashboard} alt="" />

        <div className="floating-card">
          <small>12-month forecast</small>

          <h3>On track</h3>

          <div className="progress">
            <span></span>
          </div>
        </div>

      </div>

    </section>
     <section className="core-values" id="">
      <div className="core-values-container">
        {coreValuesData.map((item, index) => (
          <div
            key={index}
            className={`core-value-card ${
              index !== coreValuesData.length - 1 ? "border-right" : ""
            }`}
          >
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
     <header className="tc-header" id="">
      <div className="tc-container">
        {/* Navigation */}
        <nav className="tc-nav">
          <a href="#HOW WE CAN HELP">Services</a>
          <a href="#WHY TOTAL CARE ADVISORY">Why us</a>
          <a href="#WHO WE HELP">Who we help</a>
          <a href="#LET'S TALK">Contact</a>
        </nav>
      </div>
    </header>
     <section className="finance-services" id="HOW WE CAN HELP">
      <div className="finance-container">

        <div className="finance-header">

          <div className="finance-left">
            <span className="finance-tag">HOW WE CAN HELP</span>

            <h2>
              Specialist CQC support at every stage of your journey.
            </h2>
          </div>

          <div className="finance-right">
            <p>
             From preparing your first application to maintaining assurance across an established group,
              our support is focused, proportionate and built around your service.
            </p>
          </div>

        </div>

        <div className="finance-grid">
          {financeServices.map((item) => (
            <div className="finance-card" key={item.id}>
              <span className="finance-number">{item.id}</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              <a href="/">
                Learn more <span>↗</span>
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
     <section className="cf-wrapper" id="WHY TOTAL CARE ADVISORY">
      <div className="cf-layout">
        {/* Left Side */}
        <div className="cf-intro">
          <span className="cf-label">
            — WHY TOTAL CARE ADVISORY
          </span>
           

          <h2 className="cf-title">
            Compliance should create
            <br />
           confidence, not just
            <br />
            paperwork.
          </h2>

          <p className="cf-description">
           We translate regulatory expectations into clear evidence and manageable actions. Your team understands 
           what good looks like, why it matters and how to demonstrate it consistently.
          </p>

          <button className="cf-button" >
            <a href="#LET'S TALK">Meet your CQC Specialist ↗</a>
          </button>
        </div>

        {/* Right Side */}
        <div className="cf-services">
          {financeData.map((item) => (
            <div className="cf-card" key={item.no}>
              <span className="cf-count">{item.no}</span>

              <div className="cf-info">
                <h3>{item.heading}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
     <section className="wh-section" id="WHO WE HELP">
      <div className="wh-container">
        <div className="wh-left">
          <div className="wh-tag">
            <span className="wh-line"></span>
            <p>WHO WE HELP</p>
          </div>

          <h2>
            CQC support shaped around  your care
            <br />
            service.
          </h2>

          <p className="wh-description">
          Whether you are applying to register, preparing for inspection or responding to a challenging outcome, 
          we tailor the support to your setting, risks and priorities.
          </p>
        </div>

        <div className="wh-right">
          {careTypes.map((item, index) => (
            <div className="wh-card" key={index}>
              <span className="check">✓</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="consultation-section" id="LET'S TALK">
      <div className="consultation-container">

        {/* Left Content */}
        <div className="consult-content">
          <span className="consultation-tag">
            <span className="line"></span>
            LET'S TALK COMPLIANCE
          </span>

          <h1>
            Ready to feel more 
            <br />
           confident about CQC?
          </h1>

          <p>
           Book a free, no-obligation conversation with our CQC compliance team.
          </p>
        </div>    

         <div className="consultation-form">
        <h2>Book your free consultation</h2>

        <p className="consultation-description">
          Tell us where you are in your CQC journey and we'll arrange a
          convenient time to talk.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            {/* Name */}
            <div className="form-group">
              <label htmlFor="fullName">YOUR NAME</label>

              <input
                id="fullName"
                type="text"
                name="fullName"
                placeholder="Full name"
                required
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label htmlFor="email">WORK EMAIL</label>

              <input
                id="email"
                type="email"
                name="email"
                placeholder="you@carebusiness.co.uk"
                required
              />
            </div>
          </div>

          {/* Organisation */}
          <div className="form-group organisation-group">
            <label htmlFor="organisation">ORGANISATION</label>

            <input
              id="organisation"
              type="text"
              name="organisation"
              placeholder="Care service or provider name"
              required
            />
          </div>

          {/* Submit */}
          <button type="submit" className="consultation-btn">
            <span>Request a consultation</span>
            <span className="button-arrow">↗</span>
          </button>
        </form>

        <p className="bottom-text">
          Prefer email?{" "}
          <a href="mailto:info@totalcareadvisory.com">
            info@totalcareadvisory.com
          </a>
        </p>
      </div>

      </div>
    </section>
    </>
  )
}

export default CQC_Services
